import React from 'react';
import GandiJayanti2023 from 'views/GandiJayanti2023'

const SchoolProgrampage = () => {
  return <GandiJayanti2023 />;
};

export default SchoolProgrampage;